// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

export interface InsufficientModalState {
    isOpen: boolean;
    modalType?: "order" | "wishList" | "invoice";
}

const initialState: InsufficientModalState = {
    isOpen: false,
};

const reducer = {
    "InsufficientModal/CompleteSetIsOpen": (draft: Draft<InsufficientModalState>, action: InsufficientModalState) => {
        if (!action.isOpen) {
            return initialState;
        }

        draft.isOpen = action.isOpen;
        draft.modalType = action.modalType;
    },
};

const xInsufficientModal = createTypedReducerWithImmer(initialState, reducer);

(reducers as any).xInsufficientModal = xInsufficientModal;

export type xInsufficientModalState = {
    xInsufficientModal: InsufficientModalState;
} & ApplicationState;
